import user from './user';
import env from './env';
import system from './system';
import routes from './routes';
import config from './config';
import aside from './aside';
import rightPopUps from './rightPopUps';

export default {

    /** 环境变量 */
    env,

    /** 用户数据 */
    user,

    /** 侧边栏 */
    aside,

    /** 侧边栏(弹窗) */
    rightPopUps,

    /** 配置数据 */
    config,

    /** 系统数据 */
    system,

    /** 路由数据 */
    routes,
};


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/index.ts